// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"231":"component---node-modules-shapeable-gatsby-theme-shapeable-src-components-app-tsx","715":"component---node-modules-shapeable-gatsby-theme-shapeable-src-pages-404-tsx"}[chunkId] + "-" + {"231":"4fbfe01f210f42d2249b","715":"e9018b29a590ee593fba"}[chunkId] + ".js";
};